import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { Typography, Button, Stack } from '@mui/material';
import { TrayArrowUp } from 'mdi-material-ui';
import PropTypes from 'prop-types';
const UploadDragAndDrop = ({ supportedFormats = [], maxFileSize = '10 MB', onChange, accept = '', multiple = false, }) => {
    const inputFileRef = useRef(null);
    const handleDrop = (e) => {
        e.preventDefault();
        let selectedFiles = e.dataTransfer.files;
        for (let i = 0; i < selectedFiles.length; i++) {
            onChange(selectedFiles[i]);
        }
    };
    const handleDragOver = (event) => {
        event.preventDefault();
    };
    const addFiles = (e) => {
        let selectedFiles = e.target.files || [];
        for (let i = 0; i < selectedFiles.length; i++) {
            onChange(selectedFiles[i]);
        }
    };
    return (_jsxs(Stack, Object.assign({ spacing: 3 }, { children: [_jsxs(Typography, Object.assign({ variant: "h5", fontWeight: "fontWeightSemiBold" }, { children: [multiple ? 'Files' : 'File', " Upload via your folder"] })), _jsxs(Stack, Object.assign({ direction: "row", onDrop: handleDrop, onDragOver: handleDragOver, sx: {
                    padding: '8px',
                    border: '1px dashed #4e3bc9',
                    borderRadius: '5px',
                    alignItems: 'center',
                } }, { children: [_jsxs(Button, Object.assign({ size: "small", variant: "contained", startIcon: _jsx(TrayArrowUp, {}), sx: { fontWeight: 400, flexGrow: 1 }, onClick: () => { var _a; return (_a = inputFileRef === null || inputFileRef === void 0 ? void 0 : inputFileRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }, { children: ["Upload ", multiple ? 'Files' : 'File'] })), _jsx("input", { type: "file", multiple: true, hidden: true, accept: accept, ref: inputFileRef, onChange: (event) => addFiles(event) }), _jsxs(Typography, Object.assign({ variant: "body2", pl: 10, pr: 10, sx: { flexGrow: 1 } }, { children: ["Or Drop ", multiple ? 'Files' : 'File'] }))] })), _jsx(Typography, Object.assign({ variant: "caption" }, { children: `${supportedFormats && supportedFormats.length > 0
                    ? `Supported format: ${supportedFormats.join(', ')} only, Size: ${maxFileSize} max.`
                    : `Maximum upload size: ${maxFileSize}.`}` }))] })));
};
UploadDragAndDrop.propTypes = {
    supportedFormats: PropTypes.array,
    maxFileSize: PropTypes.string,
    onChange: PropTypes.func,
};
export default UploadDragAndDrop;
